import React, {useEffect, useState} from 'react'
// import VISA from '../../../media/felsv/Visa.png'
import '../styles/tableSuscripcion.css'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../reducers'
import {Pagination} from '../../../components/Pagination'
import {getFechaCA} from '../../../utils/stringDate'
import {suscripcionSetSeleccion} from '../../../actions/suscripcion/suscripcion.actions'
import FilterButton from '../../../components/Tables/TableComponent/FilterButton'
import Tooltip from '../../../components/Inputs/Tooltip'
import SubirComprobanteIcon from '../../../media/felsv/DarkDocumentCheck.svg'

const TableFacturasEmitidas = () => {
  const [currentItems, setCurrentItems] = useState<Array<any>>([])
  const filtradas = useSelector((state: State) => state.suscripcion.suscripcionesFiltradas)
  const {planFacturas} = useSelector((state: State) => state.catalogos)
  const history = useHistory()
  const dispatch = useDispatch()
  const [sortedData, setSortedData] = useState<Array<any>>([])
  const {datos} = useSelector((state: State) => state.userLogin)
  const {datosSuscripcion, seleccion} = useSelector((state: State) => state.suscripcion)
  const [modalSubirComprobanteGeneral, setModalSubirComprobanteGeneral] = useState(false)
  const [dataModal, setDataModal] = useState<any>(null)

  useEffect(() => {
    setSortedData(filtradas)
  }, [filtradas])

  const elegir = async (seleccion: any) => {
    if(datos?.role !== '2') return
    await dispatch(suscripcionSetSeleccion(seleccion))
    history.push('/suscripcion/factura')
  }
  return (
    <div className='w-100 mt-16' style={{overflow: 'auto'}}>
      <div className='tab-plane mt-16' style={{overflow: 'auto'}}>
        <table className='table-main-responsive responsive-table-main td-left table-pointer'>
          <thead>
            <tr>
              <td>Plan<FilterButton data={sortedData} keyName='numero' state={(items: Array<any>) => setSortedData(items)}/></td>
              <td>Descripción <FilterButton data={sortedData} keyName='descripcion' state={(items: Array<any>) => setSortedData(items)}/></td>
              <td>Fecha <FilterButton data={sortedData} keyName='fecha_inicio' state={(items: Array<any>) => setSortedData(items)}/></td>
              <td>Estado <FilterButton data={sortedData} keyName='estado' state={(items: Array<any>) => setSortedData(items)}/></td>
              <td>Período del servicio <FilterButton data={sortedData} keyName='fecha_inicio' state={(items: Array<any>) => setSortedData(items)}/></td>
              <td>Acciones</td>
            </tr>
          </thead>
          <tbody>
            {filtradas.length === 0 ? (
              <tr>
                <td colSpan={5}>
                  <div
                    style={{
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '20px',
                      padding: '1%',
                    }}
                  >
                    Sin datos disponibles.
                  </div>
                </td>
              </tr>
            ) : (
              currentItems.map((el, i) => (
                <tr key={i}>
                  <td data-label='Plan'>{planFacturas?.find((plan) => `${plan?.idtiposuscripcion}` === `${el?.idsuscripcion}`)?.nombresuscripcion}</td>
                  <td data-label='Descripción'>{planFacturas?.find((plan) => `${plan?.idtiposuscripcion}` === `${el?.idsuscripcion}`)?.descripcion}</td>
                  <td data-label='Fecha'>{getFechaCA(el?.fechasuscripcion)}</td>
                  <td data-label='Estado'>{el?.estado ? 'Activo' : 'Finalizado'}</td>
                  <td data-label='Período del servicio'>
                    {getFechaCA(el?.fechasuscripcion)} - {getFechaCA(el?.fechaexpira)}
                  </td>
                  <td data-label='Acciones'>
                    <Tooltip text="Ver detalles">
                      <button onClick={() => elegir(el)} className="table-action">
                          <img style={{height: '15px', width: '15px'}} src={SubirComprobanteIcon} className="table-img-action" alt="Upload"/>
                      </button>
                    </Tooltip>                 
                  </td>
                  {/* <td data-label='Forma de pago'>
                    <img src={VISA} alt='visa' className='table-suscripcion-img' /> **** **** ****
                    1234
                  </td> */}
                </tr>
              ))
            )}
          </tbody>
        </table>
        <Pagination
          data={sortedData}
          state={(items: Array<any>) => setCurrentItems(items)}
          items={15}
        />
      </div>
    </div>
  )
}

export default TableFacturasEmitidas
